import {NavBar} from "../../organisms/NavBar/NavBar";
import {
    Button,
    TableRow,
    Typography,
    Box,
    Table,
    TableContainer,
    TableHead,
    TableCell,
    Paper,
    TableBody,
    Snackbar
} from "@mui/material";
import {useGetUserTrends} from "../../../hooks/getMyTrends/getMyTrends";
import {MyTrendsHeaders} from "./components/MyTrendsHeaders";
import {ActiveTrend} from "../../../types/nbaTypes";
import {useNavigate} from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {useDeleteTrend} from "../../../hooks/deleteTrend/deleteTrend";
import React, {useState} from "react";
import {useAuth} from "../../../AuthContext/authContext";
import {EditTrendDialog} from "./components/EditTrendDialog";
import {TrendsTable} from "./components/TrendsTable";

export const MyTrendsPage = ({}) => {

    const {loggedInUserEmail} = useAuth()
    const navigate = useNavigate()
    const { deleteTrend } = useDeleteTrend();
    const [isSnackBarOpen, setIsSnackBarOpen] = useState(false)
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)
    const [selectedTrend, setSelectedTrend] = useState<ActiveTrend | undefined>()
    const [deletedTrend, setDeletedTrend] = useState('')
    const {data, loading} = useGetUserTrends(!loggedInUserEmail);
    const {userTrends: userTrendData} = data || {};
    const userTrends = userTrendData?.filter((trend: ActiveTrend) => !trend.isDefaultUserTrend)
    const defaultUserTrends = userTrendData?.filter((trend: ActiveTrend) => trend.isDefaultUserTrend)

    const handleNavigate = (e: any, trend: ActiveTrend) => {
        setSelectedTrend(trend);
        navigate(`/${trend.sport}-query?query-string=${encodeURIComponent(trend.trend)}`)
    }

    const handleDelete = async (e: any, trend: ActiveTrend) => {
        setDeletedTrend(trend?.trend);
        e.stopPropagation()
        const {data} = await deleteTrend(trend.id)
        if(data?.deleteTrend?.id) {
            setIsSnackBarOpen(true)
        }
    };

    const handleOpenEditDialog = (e: any, trend?: ActiveTrend) => {
        e.stopPropagation();
        setIsEditDialogOpen(!isEditDialogOpen);
        setSelectedTrend(trend);
    };

    return (
        <>
            <NavBar />
            <Typography
                component="p"
                variant="h6"
                align="center"
                color="grey"
                fontWeight={100}
                pl={3.5}
                pr={3.5}
                mt={2}
            >
                My Trends
            </Typography>
            <Box
                display="flex"
                justifyContent="center"
            >
                <TrendsTable
                    trends={userTrends}
                    handleDelete={handleDelete}
                    handleOpenEditDialog={handleOpenEditDialog}
                    handleNavigate={handleNavigate}
                    selectedTrend={selectedTrend}
                    isEditDialogOpen={isEditDialogOpen}
                />
            </Box>
            <Typography
                component="p"
                variant="h6"
                align="center"
                color="grey"
                fontWeight={100}
                pl={3.5}
                pr={3.5}
            >
                Default Trends
            </Typography>
            <Box
                display="flex"
                justifyContent="center"
            >
                <TrendsTable
                    trends={defaultUserTrends}
                    handleDelete={handleDelete}
                    handleOpenEditDialog={handleOpenEditDialog}
                    handleNavigate={handleNavigate}
                    selectedTrend={selectedTrend}
                    isEditDialogOpen={isEditDialogOpen}
                />
            </Box>
            <Snackbar
                open={isSnackBarOpen}
                autoHideDuration={5000}
                onClose={() => setIsSnackBarOpen(false)}
                message={`Successfully Deleted Trend: ${deletedTrend}`}
            />
            <EditTrendDialog
                handleOpenEditDialog={handleOpenEditDialog}
                isOpen={isEditDialogOpen}
                trend={selectedTrend}
            />
        </>
    )
}